import { gql } from '@apollo/client';

export default gql`
  mutation upgradeWithPoints(
    $bookingReference: String!
    $membershipNumber: String!
    $numberOfPassengers: Int
    $legsPerPassenger: Int = 1
    $upgradeJourneys: [UpgradePointsJourneyInput!]
    $journeyType: JourneyType!
    $origin: String!
    $destination: String!
    $departureDateTime: String!
    $fromTravelClass: ClassEnum!
    $toTravelClass: ClassEnum!
    $carrier: CarrierCode
    $useNewLoyaltySystem: Boolean
    $fromTravelClassOfService: ClassOfServiceEnum
    $toTravelClassOfService: ClassOfServiceEnum
    $actionBy: String
  ) {
    upgradeWithPoints(
      bookingReference: $bookingReference
      membershipNumber: $membershipNumber
      numberOfPassengers: $numberOfPassengers
      legsPerPassenger: $legsPerPassenger
      upgradeJourneys: $upgradeJourneys
      journeyType: $journeyType
      origin: $origin
      destination: $destination
      departureDateTime: $departureDateTime
      fromTravelClass: $fromTravelClass
      toTravelClass: $toTravelClass
      carrier: $carrier
      useNewLoyaltySystem: $useNewLoyaltySystem
      fromTravelClassOfService: $fromTravelClassOfService
      toTravelClassOfService: $toTravelClassOfService
      actionBy: $actionBy
    ) {
      activityId
      pointsSpent
    }
  }
`;
